import { LitElement, html, css, utils } from '@hh/global.js'

class HHMarquee extends LitElement {
  static properties = {
    textContent: {
      type: Object,
    },
    currentLeft: {
      type: Number,
      reflect: true,
    },
    speed: {
      type: Number,
      reflects: true,
    },
    stopped: {
      type: Boolean,
      reflects: true,
    },
  }

  constructor() {
    super()
    this.textContent = utils.one('[data-content]')
    this.speed = utils.isIOS() ? this.speed / 2 : this.speed
  }

  firstUpdated() {
    const motionIsReduced = window.matchMedia(
      `(prefers-reduced-motion: reduce)`
    )
    if (motionIsReduced.matches) {
      return
    }

    this.containerLeft = utils
      .one('.marquee', this.renderRoot)
      .getBoundingClientRect().left
    this.currentLeft = 0
    this.stopped = this.stopped === 'true'
    this.speed = this.speed ? Number(this.speed) : 1

    this.addEventListener('mouseenter', () => (this.stopped = true))
    this.addEventListener('mouseleave', () => (this.stopped = false))

    this.animationLoop()
  }

  animationLoop() {
    if (this.stopped)
      return window.requestAnimationFrame(() => this.animationLoop())
    const wrapper = utils.one('[data-wrapper]', this.renderRoot)
    const firstListItem = utils.one('span', wrapper)
    const rightSideOfFirstItem = firstListItem.getBoundingClientRect().right
    if (rightSideOfFirstItem <= this.containerLeft) {
      this.currentLeft = -1
      wrapper.appendChild(firstListItem.cloneNode(true))
      firstListItem.remove()
    }
    this.currentLeft -= this.speed
    window.requestAnimationFrame(() => {
      this.animationLoop()
    })
  }

  render() {
    return html`
      <div class="marquee" style="margin-left: ${this.currentLeft}px;">
        <div class="inner" data-wrapper>
          ${[...Array(15).fill(null)].map(
            (i) =>
              html`
                <span class="item">${this.textContent.cloneNode(true)}</span>
              `
          )}
        </div>
      </div>
    `
  }

  static styles = css`
    .marquee {
      overflow: hidden;
    }

    .inner {
      width: 100%;
      display: flex;
      width: fit-content;
      white-space: nowrap;
    }

    .item {
      display: block;
      width: 100%;
      min-width: max-content;
      padding-inline: 1rem;
    }

    a {
      font: var(--hh-body-font);
      color: var(--hh-color-text);
      text-decoration: none;
    }

    a:not(class):hover {
      color: var(--hh-color-inline);
      text-decoration: underline;
    }
  `
}

customElements.define('hh-marquee', HHMarquee)
